 import Client from "./client";

export default class Transactions {
    constructor() {
        this.client = new Client()
    }

    async prices(currency) {
        return this.client.http().get(`/v1/prices/${currency}`)
    }

    async checkoutLink(data) {
        return this.client.http().post("/v1/checkout/link", data)
    }

    async startTrial(data) {
        return this.client.http().post("/v1/trial", data)
    }

    async getCurrencyRates(currency) {
        return this.client.http().get(`/v1/currency-rates/${currency}`)
    }

    async getPricesForProduct(type, ref, currency, variant = null) {
        const data = {
            product_type: type,
            reference: ref,
            currency
        }

        if (variant) {
            data.options = { variant: variant }
        }

        return this.client.http().post("/v1/prices", data)
    }

    async getPaymentTokens() {
        return this.client.http().get("/v1/payment-tokens")
    }

    async deletePaymentToken(tokenId) {
        return this.client.http().delete("/v1/payment-token", {
            data: { token_id: tokenId }
        })
    }

    async saveCard({ lang, currency } = {}) {
        return this.client.http().post("/v1/payment-token/save", { lang, currency })
    }

    async saveCardSession({ lang, currency } = {}) {
        return this.client.http().post("/v1/payment-token/save-session", { lang, currency })
    }
}